module.exports = __webpack_public_path__ + "fonts/400-italic-cyrillic.11d314b.woff2";